@if (product$ | async; as product) {
<ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: product }">
  <span class="brand">{{ product?.brand?.name }}</span>
  <h1 class="name" [class.is-discontinued]="isDiscontinued && isDiscountinuedEnabled" [innerHTML]="product?.name"></h1>
  @if (isDiscontinued && isDiscountinuedEnabled) {
  <span class="text discontinued">{{ 'product.discontinued' | cxTranslate }}</span>
  }
  <div class="product-summary">
    <span class="attr-name">{{ 'product.productSummary.code' | cxTranslate }}</span>
    <span class="attr-value"> {{ product?.code }}</span>
    <span class="attr-name">{{
      businessType == 'fish'
        ? ('product.productSummary.eanFish' | cxTranslate)
        : janCodeEnabled
        ? ('product.productSummary.jan' | cxTranslate)
        : ('product.productSummary.ean' | cxTranslate)
    }}</span>
    <ng-container>
      @if (product?.jan || product?.ean) {
      <span class="attr-value">
        {{ janCodeEnabled ? product?.jan || product?.ean : product?.ean }}
      </span>
      }
    </ng-container>
    <span class="attr-name">{{ 'product.productSummary.upc' | cxTranslate }}</span>
    <span class="attr-value"> {{ product?.upc }}</span>
    @if (product?.modelName) {
    <span class="attr-name">{{ 'product.productSummary.modelName' | cxTranslate }}</span>
    <span class="attr-value model-name"> {{ product?.modelName }}</span>
    } @if (product?.seriesName) {
    <span class="attr-name">{{ 'product.productSummary.seriesName' | cxTranslate }}</span>
    <span class="attr-value"> {{ product?.seriesName }}</span>
    }
  </div>
</ng-template>
}
